import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AccountRoutingModule } from './account-routing.module';
import { DfFormlyModule } from '@degreed/fresco';
import { SharedModule } from '@app/shared/shared.module';

// components
import { LoginFormComponent } from './components/login-form/login-form.component';
import { LoginViewComponent } from './components/login-view/login-view.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SignupFormComponent } from './components/signup-form/signup-form.component';
import { AccountFormsComponent } from './components/account-forms/account-forms.component';
import { ForgotPasswordFormComponent } from './components/forgot-password-form/forgot-password-form.component';

// services
import { ChangePasswordFormComponent } from './components/change-password-form/change-password-form.component';
import { FormFieldsModule } from '@app/form-fields/form-fields.module';
import { TagsModule } from '@app/tags/tags.module';

@NgModule({
  declarations: [
    LoginFormComponent,
    LoginViewComponent,
    ResetPasswordComponent,
    SignupFormComponent,
    AccountFormsComponent,
    ForgotPasswordFormComponent,
    ChangePasswordFormComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    AccountRoutingModule,
    DfFormlyModule.forRoot(),
    // FormFieldsModule,
  ],
  exports: [
    LoginFormComponent,
    LoginViewComponent,
    ResetPasswordComponent,
    SignupFormComponent,
    AccountFormsComponent,
    ForgotPasswordFormComponent,
    ChangePasswordFormComponent,
  ],
  providers: [],
})
export class AccountModule {}
